import { PermissionRoute, type PermissionRouteData } from '@exam-management/permission-route';
import { useParams } from '@exam-management/router';

export default function QSetReviewSubtaskRouteController() {
  const { taskId, subTaskId } = useParams('/my-task/qset-review/:taskId/subtask/:subTaskId');
  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details',
      requiredPermission: [],
      params: {
        taskId,
        subTaskId,
      },
    },
    {
      path: '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details',
      requiredPermission: [],
      params: {
        taskId,
        subTaskId,
      },
    },
    {
      path: '/my-task/qset-review/:taskId/subtask/:subTaskId/review-result',
      requiredPermission: [],
      params: {
        taskId,
        subTaskId,
      },
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
